	import Screen from '../../components/screen';
import { products, TProduct } from '../../helpers/product.helper';
import Container from '../../components/container';
import ScreenTitle from '../../components/screen-title';

export default function Products() {
	const productRender = (product: TProduct) => {
		const productInfo = (
			<div className={'space-y-3'}>
				<p className={'text-3xl pb-3'}>
					{product.name}
				</p>
				<p className={'roboto'}>
					{product.description}
				</p>
				<div className={'pt-2'}>
					{product.characteristics && <p className={'text-lg'}>Características:</p>}
					{product.behavior && <p className={'text-lg'}>Funcionamento:</p>}
					{product.types && <p className={'text-lg'}>Tipos:</p>}
					<ul className={'roboto list-disc pl-8'}>
						{product.characteristics && product.characteristics.map((characteristic, index) => (
							<li key={`characteristic_${index}`}>{characteristic}</li>
						))}

						{product.behavior && product.behavior.map((behavior, index) => (
							<li key={`behavior_${index}`}>{behavior}</li>
						))}

						{product.types && product.types.map((type, index) => (
							<li key={`type_${index}`}>{type}</li>
						))}
					</ul>
				</div>
			</div>
		);
		const productImage = (
			<div className={'w-full h-full'}>
				<img className={'max-w-sm max-h-80'} src={product.image} alt={product.name}/>
			</div>
		);

		return (
			<div>
				<div className={'grid grid-cols-3 grid-rows-1 gap-8'}>
					<div className={'col-span-3 lg:col-span-2'}>{productInfo}</div>
					<div className={'col-span-1'}>{productImage}</div>
				</div>
			</div>

		);
	}

	return (
		<Screen>
			<ScreenTitle title={'Produtos'}/>

			<Container>
				<div className={'space-y-12'}>
					{products.map((product, index) => (
						<section className={'space-y-12'} key={`product_${index}`}>
							{productRender(product)}
							<div className={'flex justify-start items-center'}>
								{index < products.length - 1 &&
                                    <div className={'border-4 border-primary w-96 my-4'}></div>}
							</div>
						</section>
					))}
				</div>
			</Container>
		</Screen>
	);
}